import './instrument';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { AuthProvider } from './lib/auth-context';
import { BillingProvider } from './lib/billing-context';
import App from './app';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AuthProvider>
      <BillingProvider>
        <App />
      </BillingProvider>
    </AuthProvider>
  </React.StrictMode>,
);
